import { Dialog, Tooltip } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

const UserDeleteConfirmation = ({
  showUserDeleteConfirmation,
  isInGroup,
  user_GroupName,

  setShowUserDeleteConfirmation,
  handleDeleteUser,
}: {
  showUserDeleteConfirmation: boolean;
  isInGroup: boolean;
  user_GroupName: any;

  setShowUserDeleteConfirmation: React.Dispatch<React.SetStateAction<boolean>>;

  handleDeleteUser: () => void;
}) => {
  const cancleDelete = () => {
    setShowUserDeleteConfirmation(false);
  };

  return (
    <div>
      <Dialog open={showUserDeleteConfirmation} onClose={cancleDelete}>
        <div className="access-remove-modal">
          <div className="access-remove-modalContent-close">
            <Tooltip title="Close"
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: '12px',
                  },
                },
              }}
            >
              <CloseIcon
                onClick={() => setShowUserDeleteConfirmation(false)}
                sx={{
                  fontSize: 'large',
                  color: '#545454',
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'red',
                  },
                }}
              />
            </Tooltip>
          </div>

          <div className="access-remove-modalContent-p">
            <p>
              Are you sure you want to delete the {!isInGroup ? 'user' : 'group'} {user_GroupName}?
            </p>
          </div>
          <div className="access-remove-modalContent-Buttons">
            <button onClick={cancleDelete} className="access-remove-modalCancel">
              Cancel
            </button>
            <button onClick={handleDeleteUser} className="access-remove-modalConfirm">
              Confirm
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default UserDeleteConfirmation;
